import React, { useEffect } from 'react';
import { Grid } from '@material-ui/core';
import GuardCardItem from './GuardCardItem';
import { ChevronLeft, ChevronRight } from '@material-ui/icons';
import { connect } from 'react-redux';
import { userActionsTypes } from '../../redux/user/actions';

function GuardCard({
  openGuardCard = false,
  classes,
  handleOpenClose,
  doctorInfo,
  setOnGuard,
}) {
  const specialty = doctorInfo?.specialty;

  return (
    <>
      <div
        onClick={handleOpenClose}
        className={[
          classes.iconContainer,
          openGuardCard
            ? classes.openCardIconPosition
            : classes.closedCardIconPosition,
        ].join(' ')}
      >
        {openGuardCard ? (
          <ChevronRight className={classes.icon} />
        ) : (
          <ChevronLeft className={classes.icon} />
        )}
      </div>
      <Grid
        container
        direction='column'
        alignItems='center'
        className={[
          classes.gridContainer,
          openGuardCard
            ? classes.openCardContainerWidth
            : classes.closedCardContainerWidth,
        ].join(' ')}
      >
        <span style={{ margin: '1rem' }}>
          <strong>Guardia</strong>
        </span>
        <GuardCardItem
          text={specialty?.name}
          switchChecked={doctorInfo?.on_guard}
          classes={classes}
          handleSwitchChange={(checkState) => {
            setOnGuard(checkState);
          }}
        />
      </Grid>
    </>
  );
}

const mapStateToProps = ({ session, user, appointments }) => {
  return {
    doctorInfo: user.user,
    session,
    appointments: appointments,
    user,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setOnGuard: (onGuard) =>
      dispatch({
        type: userActionsTypes.SET_ON_GUARD,
        payload: { body: { on_guard: onGuard } },
      }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(GuardCard);
